<div class="d-flex flex-column align-items-{{slideData.alignment || alignments.CENTER}} justify-content-center row slide-image-widget">
  <div class="d-flex flex-column align-items-center align-items-sm-start justify-content-center image-container" [style.width.%]="slideData.percentageWidth">
    <div class="w-100">
      <div
        [modalImage]="image"
        [appWatermark]="watermarkEnabled"
        [id]="slideData?.id"
        [class.cursor-pointer]="slideData.mediaImage?.link?.uri"
        (click)="openImageUrl()">

        @if (!preventImageDownload) {
          <img
            [cropImage]="image?.uri || image?.url"
            [crop]="image?.crop"
            [additionalOptions]="slideData?.mediaImage?.additionalMediaProps"
            [borderStyle]="slideData.border"
            [dropShadow]="slideData.dropShadow"
            class="slide-image align-self-start w-100"
            [alt]="slideData?.mediaImage?.description || 'Slide image'">
        } @else {
          <div
            [cropImage]="image?.uri || image?.url"
            [crop]="image?.crop"
            [additionalOptions]="slideData?.mediaImage?.additionalMediaProps"
            class="image-background border-rounded align-self-start w-100"
            [borderStyle]="slideData.border"
            [dropShadow]="slideData.dropShadow"
            [setContainerRatioAndSize]="true">
          </div>
        }

      </div>
      @if (slideData.captionText) {
        <figcaption class="image-video-caption">
          <span class="caption">{{slideData.captionText}}</span>
        </figcaption>
      }
    </div>
  </div>
</div>
